import "apollo-algolia-autocomplete/styles.css";
import Autocomplete from "apollo-algolia-autocomplete";
import React from "react";
import { Box } from "@chakra-ui/react";

const Search = () => {
  return (
    <Box
      w={{ base: "280px" }}
      sx={{
        ".aa-DetachedSearchButton": {
          borderColor: "#DEE2E7",
          _hover: {
            borderColor: "#D3D3D3",
            transition: "all 0.1s ease-in-out",
          },
        },
        ".aa-Autocomplete[aria-expanded=true]": {
          visibility: "visible!important",
        },
      }}
    >
      <Autocomplete
        appId="Q0CJ63JM7B"
        apiKey="ef1ac4e3c439bc17a8e7572700691efc"
        currentSource="graphql_com"
        inputPlaceholder="Search for GraphQL resources"
        returnFocusOnClose
        isExternal
        sources={{
          graphql_com: {
            headerTitle: "GraphQL.com",
          },
        }}
      />
    </Box>
  );
};

export default Search;
